import { i18n } from '@lingui/core';
import { MessageBus } from '@podium/browser';
import type {
    BapResultEntry,
    SearchKey,
} from '@schibsted-nmp/search-frontend-clients/quest';
import { BapSearchAd } from '@schibsted-nmp/search-frontend-components/react';
import React from 'react';
import { usePolePositionData } from '../data/PolePositionData';
import type { SearchParams } from '../data/QueryKeys';
import { useSearchFilters } from '../data/SearchFilters';
import { useSearchLayout, type Layout } from '../data/SearchLayout';
import { FavoriteHeart } from './FavoriteHeart';

const messageBus = new MessageBus();

type PolePositionAdProps = {
    initialLayout: Layout;
    initialSearchKey: SearchKey;
    initialSearchParams: SearchParams;
};

export function PolePositionAd(props: PolePositionAdProps) {
    const { initialLayout, initialSearchKey, initialSearchParams } = props;

    const { searchKey, searchParams } = useSearchFilters(
        initialSearchKey,
        initialSearchParams,
    );

    const { layout } = useSearchLayout(initialLayout);

    const { polePositionData } = usePolePositionData(searchKey, searchParams);

    React.useEffect(
        function publishStatusMessage() {
            const status = polePositionData?.result ? 'RESULT' : 'EMPTY';
            messageBus.publish('pole-position', 'status', status);
        },
        [polePositionData],
    );

    if (!polePositionData?.result) {
        return null;
    }

    const ad = polePositionData.result.searchEntry as unknown as BapResultEntry;

    return (
        <BapSearchAd
            ad={ad}
            favorite={() => (
                <FavoriteHeart
                    itemId={ad.id}
                    variant={layout === 'grid' ? 'heart-on-image' : 'heart'}
                />
            )}
            label={({ className, classes }) => (
                <span
                    className={`${className} ${classes.badge} ${classes.info}`}
                >
                    {i18n.t({
                        id: 'pole-position-ad.recommerce.badge',
                        message: 'Promoted ad',
                    })}
                </span>
            )}
            layout={layout}
            url={ad.canonical_url}
        />
    );
}
